import { Response } from '../../../../generic/v2/response/response';
import { FormRequestName } from '../../../form-request-name';

export abstract class FormResponse<T> extends Response<FormRequestName, T> {}
